import SessionEventProto from "../session-event-proto"
import asyncSessionLoader from "../../gd/data/async-session-loader"

// Define the structure of the header object used in the event
type Header = {
    task            : any           // The task object associated with the event
    projectId       : ID,           // The ID of the project associated with the event
    isBulkUpdate    : boolean       // Indicates if this is a bulk update operation
}

// Event class for handling the creation of a new project task in the session
export default class SessionProjectTaskNewEvent extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)
        this.header     = {
            task            : sessionEvent.task,
            projectId       : sessionEvent.projectId,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    async process() {
        // If the event is for a different company, do not process
        if (this.isDifferentCompany()) return false

        // Ensure all required missing data is loaded before proceeding
        await asyncSessionLoader(gd.session.findMissing({
            statuses: [this.data.taskStatusId],
        }))

        // Notify the model bus of the new or updated project task
        gd.modelBus.newUpdate('project-task', this.method, this.header.task.id, this.data, this.header)
    }
}
